exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.el-row[data-v-0c7de2c0]{margin-bottom:20px\n}\n@media (max-width: 780px){\n.inputDiv[data-v-0c7de2c0]{width:85%\n}\n}\n", "", {"version":3,"sources":["/app/frontend/src/screens/central/cadastros/para/resgateAforamento/components/Imovel.vue"],"names":[],"mappings":";AAqFA,yBACE,kBAAmB;CACpB;AAAA;AAGC,2BACE,SAAU;CACX;CAAA","file":"Imovel.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.el-row {\n  margin-bottom: 20px;\n}\n\n@media (max-width: 780px) {\n  .inputDiv {\n    width: 85%;\n  }\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0c7de2c0","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/screens/central/cadastros/para/resgateAforamento/components/Imovel.vue
// module id = pVTD
// module chunks = 11